import { atom } from 'jotai';





export interface Notification {
  type: 'success' | 'error' | 'warning' | 'info';
  title: string;
  message: string;
  duration?: number;
  dismissReportBugOption?: boolean;
}

// Notifications atom
export const notificationsAtom = atom<Notification>();
